export default "__VITE_ASSET__cae074eb__"